import { UIActionType, UIAction } from '../../actions/uiActions';

const selectedArtifactRunIdReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_SELECTED_ARTIFACT_RUN_ID) return action.id;
  return state;
};

export default selectedArtifactRunIdReducer;
